var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleThreeQuarters(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle_three_quarters"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "black",
    strokeOpacity: 0.87
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_4138_8328",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 -3.49691e-07C9.58225 -4.18853e-07 11.129 0.469191 12.4446 1.34824C13.7602 2.22729 14.7855 3.47672 15.391 4.93853C15.9965 6.40034 16.155 8.00887 15.8463 9.56072C15.5376 11.1126 14.7757 12.538 13.6569 13.6569C12.538 14.7757 11.1126 15.5376 9.56072 15.8463C8.00887 16.155 6.40034 15.9965 4.93853 15.391C3.47672 14.7855 2.22729 13.7602 1.34824 12.4446C0.469192 11.129 -2.99397e-07 9.58225 -3.49691e-07 8L8 8L8 -3.49691e-07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8 -3.49691e-07C9.58225 -4.18853e-07 11.129 0.469191 12.4446 1.34824C13.7602 2.22729 14.7855 3.47672 15.391 4.93853C15.9965 6.40034 16.155 8.00887 15.8463 9.56072C15.5376 11.1126 14.7757 12.538 13.6569 13.6569C12.538 14.7757 11.1126 15.5376 9.56072 15.8463C8.00887 16.155 6.40034 15.9965 4.93853 15.391C3.47672 14.7855 2.22729 13.7602 1.34824 12.4446C0.469192 11.129 -2.99397e-07 9.58225 -3.49691e-07 8L8 8L8 -3.49691e-07Z",
    fill: "black",
    fillOpacity: 0.87,
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 2,
    mask: "url(#path-2-inside-1_4138_8328)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleThreeQuarters);
export default __webpack_public_path__ + "static/media/circle_three_quarters.160829fb4123b62f133ffdbda9a6a576.svg";
export { ForwardRef as ReactComponent };